import { MultiplierAnimationConfig } from '@Animation/types'
import { preLoadAssets } from './asset-preloader'
import { MichiganGumballMultiplierAnimation } from './mi-gumball-multiplier-animation'

export const MI_MULTIPLIER_GUMBALL_CONFIG: MultiplierAnimationConfig = {
  assetPreloader: preLoadAssets,
  revealAnimation: MichiganGumballMultiplierAnimation,
}
